import { useState, useEffect } from "react";
import dayjs from "dayjs";
import React from "react";

import JDate from "jalali-date";

import Container from "./index-css";
const Index = ({ data }) => {
  const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);
  const [showMore3, setShowMore3] = useState(false);
  const [coverage, setCoverage] = useState({
    data: [
      {
        bodycar_coverage_id: "1",
        bodycar_coverage_name: "شکست شیشه",
        bodycar_coverage_desc:
            "از طریق این پوشش اضافی می توان خسارات وارده به موض… قرار می دهد بطور مثال شکسته شدن شیشه در اثر سرما",
        bodycar_coverage_percent: "10",
      },
    ],
  });

  useEffect(() => {
    // getCoverage();
  }, []);

  // async function getCoverage() {
  //   const result = await $postWithResult(`bodycar?command=get_coverage`);
  //   setCoverage(result);
  // }

  var nowS = new JDate(new Date()).format("YYYY");
  var now = new Date();
  var full_year = now.getFullYear();
  console.log("data",data)
  // let detail = JSON.parse(data.data[0].request_detail_json);
  //
  // console.log('detail',detail)

  // var final = [];
  // for (var i = 0; i < coverage.data.length; i++) {
  //   var flag2 = "false";
  //   for (var j = 0; j < detail.ms_coverage_detail.length; j++) {
  //     if (
  //         detail.ms_coverage_detail[j].id ===
  //       coverage.data[i].bodycar_coverage_id
  //     ) {
  //       flag2 = "true";
  //     }
  //   }
  //   if (flag2 === "false") {
  //     final.push({
  //       name: coverage.data[i].bodycar_coverage_name,
  //       status: "خیر",
  //     });
  //   } else {
  //     final.push({
  //       name: coverage.data[i].bodycar_coverage_name,
  //       status: "بله",
  //     });
  //   }
  // }

  function formatPrice(value) {
    return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  var arrPrice = [];
  try {
    arrPrice = JSON.parse(data.data[0].jsonpricing_text);
    if (arrPrice.instalment_conditions) {
      var cash = arrPrice.instalment_conditions.filter(
          (c) => c.instalment_conditions_mode_id === "0"
      );
      var check = arrPrice.instalment_conditions.filter(
          (c) =>
              c.instalment_conditions_mode_id === "1" ||
              c.instalment_conditions_mode_id === "3"
      );
    }
  } catch (e) {
    console.log(e);
  }
  //console.log(arrPrice)
  var active_star =
      parseInt(arrPrice.company_customer_satisfaction) +
      parseInt(arrPrice.company_levelof_prosperity) +
      parseInt(arrPrice.company_timeanswer_complaints);

  active_star = Math.ceil(active_star / 3 / 2);
  var deactive_star = 5 - active_star;

  const Stars = () => {
    var stars = [];
    for (var i = 0; i < active_star; i++) {
      stars.push(
          <img src="/imagess/star.png" key={i + deactive_star} alt="star icon" />
      );
    }
    return <>{stars}</>;
  };

  const Stars_ = () => {
    var dstars = [];
    for (var i = 0; i < deactive_star; i++) {
      dstars.push(
          <img
              src="/imagess/star_.png"
              alt="star icon aref24"
              key={i}
              alt="star icon"
          />
      );
    }
    return <>{dstars}</>;
  };

  const handleClick = (id) => {
    if (id === 1) {
      setShowMore1(!showMore1);
    } else if (id === 2) {
      setShowMore2(!showMore2);
    } else if (id === 3) {
      setShowMore3(!showMore3);
    }
  };
  // *******************component************component*******************component*****************component*************

  const Text = (props) => {
    return (
        <Container>
          <div className="main-textt">
            <div className="text-title">{props.title} {props.detail == undefined ? "" : ":"}</div>
            <div className="text-detail">{props.detail === "undefined" ? "" : props.detail}</div>
          </div>
        </Container>
    );
  };

  const Linetitle = (props) => {
    return (
        <Container>
          <div className="main-line">
            <div style={{ width: "100%" }} className="line">
              <div style={{ width: props.w }} className="line-text">
                {props.name}
              </div>
            </div>
          </div>
        </Container>
    );
  };

  return (
      <Container>
        <div className="main-map-detail">
          <div className="title">
            خلاصه سفارش بیـــمه
            <span
                style={{
                  color: "#1ad4a3",
                  marginRight: "5px",
                  display: "flex",
                }}
            >
            {/*بدنه*/}
          </span>
          </div>
          <Linetitle name="اطلاعات خودرو" />


          <div className="map-detail-divv">
            {data.map((item) => (
                <div
                    key={item.paramstep_name}
                    className="bg-white shadow-sm rounded-2xl p-3 border"
                >
                  <div className="text-base font-semibold text-gray-800">
                    {item.paramstep_name}
                  </div>
                  <div className="text-sm text-gray-600 mt-1">
                    {item.value || "ندارد"}
                  </div>
                </div>,

                    <Text title={item.paramstep_name} detail={item.value} />



            ))}
          </div>



          <Linetitle name="اطلاعات بیمه" />
          <div className="map-detail-divv">
            <Text title="نام بیمه" detail={arrPrice.company_name} />
            <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
            <Text
                title="مبلغ بیمه"
                detail={`${formatPrice(arrPrice.price)} ریال`}
            />
            <Text
                title="درصد تخفیف مدیریتی"
                detail={
                  arrPrice.managdiscount_amount
                      ? `${arrPrice.managdiscount_amount} درصد`
                      : "ندارد"
                }
            />


            <Text
                title="امکان خرید اقساطی"
                detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
            />
            <>
              {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
                  <Text
                      title={data.instalment_conditions_desc}
                      detail={data.instalment_conditions_amount}
                  />
              ))}
            </>
          </div>
        </div>
      </Container>
  );
};

export default Index;
